import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { store } from '@store';
import { GetAliasSetsByKeyResponse } from '@src/types/AliasSet';
import { useMemo } from 'react';

export default () => {
  const Show_Alias_Sets_Select = useMemo(
    () =>
      store.getState().config.siteMeta?.ui?.features?.Show_Alias_Sets_Select,
    [],
  );
  return useApiQuery<GetAliasSetsByKeyResponse>({
    queryKey: [QueryKeys.aliasSets],
    apiPath: `/alias-sets/current`,
    method: 'GET',
    useV2API: true,
    enabled: Show_Alias_Sets_Select,
  });
};
